import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f2d7a5a")

_pushScopeId("data-v-5f2d7a5a")
const _hoisted_1 = { class: "recommend-food-menu" }
const _hoisted_2 = { class: "recommend-food-menu-sub-dish-area" }
const _hoisted_3 = {
  key: 1,
  class: "recommend-food-menu-sub-dish-empty"
}
const _hoisted_4 = {
  key: 3,
  class: "recommend-food-menu-sub-dish-empty"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RecommenedFoodMenuItem = _resolveComponent("RecommenedFoodMenuItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_RecommenedFoodMenuItem, {
      class: "recommend-food-menu-main-dish-view",
      dishType: _ctx.DISH_TYPE.MAIN,
      dish: _ctx.getMainDish(),
      onSelectRecipe: _ctx.selectRecipe
    }, null, 8, ["dishType", "dish", "onSelectRecipe"]), [
      [_vShow, _ctx.isShowMainDish()]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      (_ctx.isShowSub1Dish())
        ? (_openBlock(), _createBlock(_component_RecommenedFoodMenuItem, {
            key: 0,
            class: "recommend-food-menu-sub-dish-view",
            dishType: _ctx.DISH_TYPE.SUB,
            dish: _ctx.getSub1Dish(),
            onSelectRecipe: _ctx.selectRecipe
          }, null, 8, ["dishType", "dish", "onSelectRecipe"]))
        : (_openBlock(), _createBlock("div", _hoisted_3)),
      (_ctx.isShowSub2Dish())
        ? (_openBlock(), _createBlock(_component_RecommenedFoodMenuItem, {
            key: 2,
            class: "recommend-food-menu-sub-dish-view",
            dishType: _ctx.DISH_TYPE.SUB,
            dish: _ctx.getSub2Dish(),
            onSelectRecipe: _ctx.selectRecipe
          }, null, 8, ["dishType", "dish", "onSelectRecipe"]))
        : (_openBlock(), _createBlock("div", _hoisted_4))
    ], 512), [
      [_vShow, _ctx.isShowSubDish()]
    ])
  ]))
})